import React, { useRef, useState, useLayoutEffect } from "react";
import {
	TextField,
	DialogHandler,
	Button,
} from "cakemail-ui-components/lib/react";
import { I18n } from "react-redux-i18n";
import PropTypes from "prop-types";

const PermanentDeleteDialogContent = (props) => {
	const [text, setText] = useState("");
	const [valid, setValid] = useState("");
	const btnRef = useRef();

	useLayoutEffect(() => {
		setTimeout(
			() =>
				document
					?.getElementById("createTemplateArea")
					?.getElementsByTagName("input") &&
				document
					.getElementById("createTemplateArea")
					.getElementsByTagName("input")[0]
					.focus(),
			50
		);
	}, []);
	function resetState() {
		setText("");
		setValid("");
		btnRef.current?.reset();
	}

	function isValidValue(value) {
		return value === props.validatorInput;
	}

	function handleAreaChange(e) {
		const value = e.currentTarget.value.toUpperCase();
		setText(value);
		if (isValidValue(value)) {
			setValid("valid");
		} else setValid("");
	}

	return (
		<>
			<p className="dialogDesc">{props.desc}</p>

			{props.extraContent(setText, setValid)}

			<TextField
				className="createTemplateInput"
				id="createTemplateArea"
				label={props.fieldLabel}
				placeholder={props.fieldPlaceholder}
				value={text}
				onChange={handleAreaChange}
				valid={valid}
				message={
					valid == "valid" ? I18n._translate("app-auth_validators_valid") : ""
				}
				onKeyUp={(e) => {
					if (isValidValue(e.currentTarget.value.toUpperCase())) {
						if (e.keyCode === 13) {
							btnRef.current.startAnimation();
							props.primaryBtnClick(text, valid, btnRef, resetState);
						}
					}
				}}
			/>

			<div className="dialogBtns">
				<Button
					shapeStyle="stroke"
					colorTheme="grey"
					size="small"
					radius="square"
					text={props.secondaryBtnText}
					onClick={() => {
						props.secondaryBtnClick();
						resetState();
					}}
				/>
				<Button
					ref={btnRef}
					shapeStyle="fill"
					colorTheme="teal"
					size="small"
					radius="square"
					animated={true}
					text={props.primaryBtnText}
					onClick={() => props.primaryBtnClick(text, valid, btnRef, resetState)}
					disabled={valid === ""}
				/>
			</div>
		</>
	);
};

/*
Remember to do the following after primary action unleased :
- DialogHandler.hide();
- reset() : fourth primaryBtnClick parameter, will reset the dialog of none other is called and used again
 */

PermanentDeleteDialogContent.propTypes = {
	validatorInput: PropTypes.string,
	extraContent: PropTypes.func, // functions that returns content
	primaryBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	primaryBtnClick: PropTypes.func,
	secondaryBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	secondaryBtnClick: PropTypes.func,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	desc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	fieldLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	fieldPlaceholder: PropTypes.string,
};

const PermanentDeleteDialog = (
	validatorInput,
	opts = {},
	extraContent = () => ""
) => {
	validatorInput = validatorInput
		? validatorInput
		: I18n.t("app-general-delete_validator");

	let options = {
		title: "",
		desc: "",
		fieldLabel: I18n.t("app-manage-attributes-list-delete_text"),
		fieldPlaceholder: I18n.t(
			"app-manage-attributes-list-delete_text_placeholder"
		),
		primaryBtnText: I18n.t("app-general-delete"),
		primaryBtnClick: () => { },
		secondaryBtnText: I18n.t("app-general-cancel"),
		secondaryBtnClick: () => {
			DialogHandler.hide();
		},
		...opts,
	};
	DialogHandler.show({
		managedByContent: true,
		title: options.title,
		content: (
			<div className="permanentDeleteDialog">
				<PermanentDeleteDialogContent
					validatorInput={validatorInput}
					extraContent={extraContent}
					{...options}
				/>
			</div>
		),
	});
};

export default PermanentDeleteDialog;
